import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の Slot）に calendar が出すもの（SFA §15.5 日程調整の公開リンク）。
 * 登録は apps/web/src/app/slots.ts（組み立て）だけが行う。crm は calendar を知らない（依存の向きを守る）。
 *
 * | id | スロット | subjectType | order | 出すもの | context |
 * |---|---|---|---|---|---|
 * | calendar.booking-link-action | record.actions | lead, customer | 30 | 「日程調整リンクを発行」（発行のダイアログ・URL は 1 回だけ表示） | lead: `lead`（LeadDetail）/ customer: subjectId・title |
 * | calendar.booking-links | record.panel | lead, customer | 45 | 「日程調整リンク」（発行済みの一覧・予約の一覧・取り消し・発行） | 同上 |
 *
 * 権限は予定を作れる人（calendar.event.write / manage）。calendar が無効な会社ではスロットが出さない。
 * 取引先の詳細には今のところ record.actions の置き場所が無いので、取引先ではパネルの「発行」から出す
 */
const BookingLinkAction = lazy(() => import('./components/booking/BookingLinkAction.js'));
const BookingLinksPanel = lazy(() => import('./components/booking/BookingLinksPanel.js'));

const WRITE = ['calendar.event.write', 'calendar.event.manage'];

export const calendarSlots: SlotEntry[] = [
  {
    id: 'calendar.booking-link-action',
    module: 'calendar',
    slot: 'record.actions',
    subjectTypes: ['lead', 'customer'],
    permission: WRITE,
    order: 30,
    Component: (props) => (
      <Suspense fallback={null}>
        <BookingLinkAction {...props} />
      </Suspense>
    ),
  },
  {
    id: 'calendar.booking-links',
    module: 'calendar',
    slot: 'record.panel',
    subjectTypes: ['lead', 'customer'],
    permission: WRITE,
    order: 45,
    Component: (props) => (
      <Suspense fallback={null}>
        <BookingLinksPanel {...props} />
      </Suspense>
    ),
  },
];
